import React from "react";
import styles from "./topbar.module.css";
import TextField from "@material-ui/core/TextField";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import InputAdornment from "@material-ui/core/InputAdornment";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Input from "@material-ui/core/Input";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";

const TopBar = (props) => {
  const isAllSelected =
    props.options3 &&
    props.options3.length > 0 &&
    props.selectValue3.length === props.options3.length;

  console.log("Top Bar");
  console.log(props);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  return (
    <div className={styles.container}>
      {props.nav && (
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {props.nav.map((val) => {
            return (
              <p onClick={val.onClick} className={styles.navLink}>
                {val.Name}
              </p>
            );
          })}
        </Breadcrumbs>
      )}
      <div className={styles.content}>
        {props.select && (
          <FormControl
            variant="outlined"
            style={{ minWidth: 140, marginRight: 15 }}
          >
            <InputLabel
              id="filled-label"
              style={{ fontSize: 14, marginBottom: 4 }}
            >
              {props.lable}
            </InputLabel>
            <Select
              labelId="filled-label"
              id="filled"
              value={props.selectValue}
              label={props.lable}
              onChange={(e) => props.handleSelectChange(e.target.value)}
            >
              {props.options.map((val, index) => {
                return <MenuItem value={props.values[index]}>{val}</MenuItem>;
              })}
            </Select>
          </FormControl>
        )}

        {props.select2 && (
          <FormControl variant="outlined" style={{ minWidth: 140 }}>
            <InputLabel id="filled-label">{props.lable2}</InputLabel>
            <Select
              labelId="filled-label"
              id="filled"
              value={props.selectValue2}
              label={props.lable2}
              onChange={(e) => props.handleSelectChange2(e.target.value)}
            >
              {props.options2.map((val, index) => {
                return <MenuItem value={props.values2[index]}>{val}</MenuItem>;
              })}
            </Select>
          </FormControl>
        )}
        {props.select3 && (
          <FormControl variant="outlined" style={{ minWidth: 140 }}>
            <InputLabel id="filled-label">{props.lable3}</InputLabel>
            <Select
              labelId="filled-label"
              id="filled"
              value={props.selectValue3}
              label={props.lable3}
              onChange={(e) => props.handleSelectChange3(e.target.value)}
              multiple={props.multiple3}
              renderValue={(selected) => {
                // if (selected.length == 0) {
                //   return "ALL";
                // }

                console.log("props");
                console.log(selected);
                console.log(selected.length);
                console.log("props selectValue3");
                console.log(props.selectValue3);
                console.log("push props.selectValue3");
                // console.log(props.selectValue3.push(selected));
                // console.log(props.selectValue3);
                return selected.join(", ");
              }}
              input={<Input />}
              MenuProps={MenuProps}
            >
              <MenuItem value="all">
                <Checkbox
                  checked={isAllSelected}
                  indeterminate={
                    props.selectValue3.length > 0 &&
                    props.selectValue3.length < props.options3.length
                  }
                />

                <ListItemText primary=" ALL" />
              </MenuItem>
              {props.options3.map((val, index) => {
                return (
                  <MenuItem key={val} value={val}>
                    <Checkbox checked={props.selectValue3.indexOf(val) > -1} />
                    <ListItemText primary={val} />
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        )}
      </div>

      <TextField
        value={props.searchValue}
        onChange={(e) => props.onSearchChange(e.target.value)}
        variant="outlined"
        color="primary"
        label="Search Here"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchRoundedIcon />
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};
export default TopBar;
